import React, { useState } from 'react'
import HeaderBack from './_HeaderBack'
import cambio from '../../assets/img/cambio.svg'
import listino from '../../assets/files/kit_contrattuale_web.pdf'
import { useSelector } from 'react-redux'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

function CambioDestinazione() {
    const navigate = useNavigate()
    const opzione = useSelector((user) => user.user.info.opzione_tariffaria)
    const [checkBox, setCheck] = useState(false)
    const [selectValue, setSelectVal] = useState('10')
    const podCode = useSelector((user) => user.user.info.pod_code)
    const customerId = useSelector((user) => user.user.info.customer_id)
    const potenza = useSelector((user) => user.user.info.potenza)
    const costo = useSelector((user) => user.faidate.costi)

    const check = async () => {
        if(!checkBox){
            alert('Devi accettare termini e condizioni')
        } else {
            const url = `https://my.revoluce.it/area_utente/gestione/api/faidate/cambioDestinazione.php?customer_id=${customerId}&codice_pod=${podCode}&attuale=${opzione}&cambio_destinazione=${selectValue}`
            await axios.get(url)
            navigate('/enrica/richiesta-inoltrata')
        }
    }
    const checkOpzione = (opzione) => {
        switch (opzione) {
            case 'D2':
                return `Residente ${parseFloat(potenza)} kW`;
            case 'D3':
                return `Non residente ${parseFloat(potenza)} kW`;
            default:
                return `Altri usi ${parseFloat(potenza)} kW`;
        }
    }
    return (
        <div className="faiDaTe_component">
            <HeaderBack text="Fai da te" step={0}/>
            <div className="icon">
                <img src={cambio} alt="cambio" />
            </div>
            <div className="body">
                <div className="paragraph">
                    <h1 className="h1">Cambio destinazione d'uso</h1>
                    <p>Qui puoi modificare la destinazione d’uso della tua utenza tra Domestico residente, Domestico non residente e Altri usi.</p>
                </div>
                <div className="paragraph">
                    <h2 className="h2">Cosa si intende per destinazione d’uso di un’utenza?</h2>
                    <p>Un’utenza elettrica può essere configurata come:</p>
                    <ul>
                        <li>Domestico Residente (prima casa);</li>
                        <li>Domestico Non Residente (seconda casa);</li>
                        <li>Altri Usi (locali commerciali, aziende oppure garage, condomini, chiese ecc...).</li>
                    </ul>
                </div>
                <div className="paragraph box">
                    <p>La destinazione d’uso di un’utenza può essere modificata a seconda della propria necessità. Per saperne di più vai sul nostro blog <a href="https://revoluce.zendesk.com/hc/it/articles/360018054638-Tipologia-d-uso-Domestico-NON-Residente-qual-%C3%A8-la-differenza-con-la-tariffa-residente-e-come-funziona"> cliccando qui</a></p>
                </div>
                <div className="paragraph">
                    <h2 className="h2">Tempi e Costi</h2>
                    <p><span className="bold">Tempo massimo di lavorazione:</span> 7 giorni lavorativi dalla richiesta del cliente.</p>
                    <p><span className="bold">Costo:</span>€ {costo !== null ? costo : ''} IVA compresa. Il costo del cambio di destinazione d’uso verrà addebitato all’interno del primo Estratto Conto utile.</p>
                </div>
                <div className="paragraph box">
                    <p>Modificando la destinazione d’uso della tua utenza il tuo prezzo al kWh e l’eventuale canone fisso mensile si andranno ad aggiornare secondo i prezzi attualmente in vigore, in base al “Listino prezzi Revoluce in vigore oggi” che puoi <a href={listino}>trovare qui</a></p>
                </div>
                <div className="paragraph boxForm">
                    <h2 className="h2">Voglio fare un cambio di destinazione d'uso</h2>
                    <div className="select">
                        <h2>Attualmente il mio contatore è di tipo:</h2>
                        <select>
                            <option value={opzione}>{checkOpzione(opzione)}</option>
                        </select>
                        <h2>Voglio cambiare la tipologia in:</h2>
                        <select onChange={(e) => setSelectVal(e.target.value)}>
                            <option value="null">Seleziona la tipologia di contatore</option>
                            <option value="domestico-residente">Domestico residente</option>
                            <option value="domestico-non-residente">Domestico non residente</option>
                            <option value="altri-usi">Altri usi</option>
                        </select>
                    </div>
                    <div className="checkbox">
                        <input type="checkbox" onChange={() => setCheck(!checkBox)}/>
                        <p>Proseguendo con l’invio della richiesta dichiaro di aver letto ed accettato le tempistiche necessarie per il completamento dell’operazione e il preventivo di costo indicato.</p>
                    </div>
                    <div className="cta">   
                        <button onClick={() => check()}>Inoltra richiesta</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CambioDestinazione
